/* ============================================
   BLOOM PDP — JavaScript
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  /* --- Product data injected by Liquid --- */
  const variants  = window.bloomVariants  || [];
  const allImages = window.bloomImages    || [];

  /* --- State --- */
  let selectedColor    = variants[0] ? (variants[0].option1 || '') : '';
  let selectedSize     = variants[0] ? (variants[0].option2 || '') : '';
  let currentVariant   = variants[0] || null;
  let galleryIndex     = 0;

  /* --- Simple money formatter (respects store currency symbol via Liquid) --- */
  function formatMoney(cents) {
    /* Prefer Shopify's built-in formatter if available */
    if (window.Shopify && window.Shopify.formatMoney) {
      const fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
      return window.Shopify.formatMoney(cents, fmt);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  /* --- Update all price / qty / variant-id UI elements --- */
  function refreshUI() {
    if (!currentVariant) return;

    const priceCents = currentVariant.price;          /* always in cents */
    const qty        = getSelectedQty();
    const discount   = qty === 2 ? 0.9 : 1;
    const totalCents = Math.ceil(priceCents * qty * discount);

    /* ATC button price pill — mobile + desktop */
    ['bloom-atc-btn', 'bloom-atc-btn-d'].forEach(function (id) {
      var btn = document.getElementById(id);
      if (!btn) return;
      var pill = btn.querySelector('.bloom-atc-price-pill');
      if (pill) pill.textContent = formatMoney(totalCents);
    });

    /* Sticky bar sub-text */
    var stickySub = document.querySelector('.bloom-sticky-sub');
    if (stickySub) stickySub.textContent = formatMoney(totalCents);

    /* Variant ID hidden inputs — mobile + desktop */
    ['bloom-variant-id', 'bloom-variant-id-d'].forEach(function (id) {
      var input = document.getElementById(id);
      if (input) input.value = currentVariant.id;
    });
  }

  /* --- Read currently selected quantity from upsell row --- */
  function getSelectedQty() {
    var sel = document.querySelector('.bloom-upsell-option.selected');
    return sel ? parseInt(sel.dataset.qty || '1', 10) : 1;
  }

  /* --- Find matching variant from selected options --- */
  function matchVariant() {
    var match = variants.find(function (v) {
      var c1 = (v.option1 || '').toLowerCase() === selectedColor.toLowerCase();
      var c2 = !selectedSize || (v.option2 || '').toLowerCase() === selectedSize.toLowerCase();
      return c1 && c2;
    });
    /* Fallback: match only on option1 (single-option products) */
    if (!match) {
      match = variants.find(function (v) {
        return (v.option1 || '').toLowerCase() === selectedColor.toLowerCase();
      });
    }
    if (match) currentVariant = match;
    refreshUI();
  }

  /* ---- MOBILE GALLERY ---- */
  var track     = document.getElementById('bloom-track');
  var dots      = document.querySelectorAll('.bloom-dot');
  var startX    = 0;
  var isDragging = false;

  function slideTo(index) {
    var total = dots.length;
    if (index < 0) index = 0;
    if (index >= total) index = total - 1;
    galleryIndex = index;
    if (track) track.style.transform = 'translateX(-' + (index * 100) + '%)';
    dots.forEach(function (d, i) { d.classList.toggle('active', i === index); });
  }

  if (track) {
    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      isDragging = true;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      if (!isDragging) return;
      isDragging = false;
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 44) slideTo(diff > 0 ? galleryIndex + 1 : galleryIndex - 1);
    }, { passive: true });
  }

  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () { slideTo(i); });
  });

  /* ---- DESKTOP GALLERY ---- */
  function setDesktopImage(src) {
    var main = document.getElementById('bloom-main-img');
    if (!main) return;
    main.style.opacity = '0';
    main.style.transition = 'opacity 0.2s';
    setTimeout(function () {
      main.src = src;
      main.style.opacity = '1';
    }, 150);
  }

  document.querySelectorAll('.bloom-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.bloom-thumb').forEach(function (t) { t.classList.remove('active'); });
      this.classList.add('active');
      setDesktopImage(this.dataset.src);
    });
  });

  /* ---- COLOR SWATCHES (mobile + desktop) ---- */
  document.querySelectorAll('.bloom-swatch-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      /* Deactivate all swatches on the whole page */
      document.querySelectorAll('.bloom-swatch-btn').forEach(function (b) {
        b.classList.remove('active');
        b.setAttribute('aria-checked', 'false');
      });
      this.classList.add('active');
      this.setAttribute('aria-checked', 'true');
      selectedColor = this.dataset.value;

      /* Update both color labels */
      ['bloom-color-label', 'bloom-color-label-d'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el) el.textContent = selectedColor;
      });

      updateGalleryForColor(selectedColor);
      matchVariant();
    });
  });

  function updateGalleryForColor(color) {
    var match = variants.find(function (v) { return v.option1 === color; });
    if (!match || !match.featured_image) return;
    setDesktopImage(match.featured_image.src);
    if (track) {
      var slides = Array.from(track.children);
      var matchSrc = match.featured_image.src.split('?')[0].split('/').pop();
      slides.forEach(function (slide) {
        var img = slide.querySelector('img');
        if (img && img.src.includes(matchSrc)) track.prepend(slide);
      });
      slideTo(0);
    }
  }

  /* ---- SIZE PILLS (mobile + desktop) ---- */
  document.querySelectorAll('.bloom-size-pill').forEach(function (pill) {
    pill.addEventListener('click', function () {
      document.querySelectorAll('.bloom-size-pill').forEach(function (p) {
        p.classList.remove('active');
        p.setAttribute('aria-checked', 'false');
      });
      this.classList.add('active');
      this.setAttribute('aria-checked', 'true');
      selectedSize = this.dataset.value;

      ['bloom-size-label', 'bloom-size-label-d'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el) el.textContent = selectedSize;
      });

      matchVariant();
    });
  });

  /* ---- UPSELL SELECTION ---- */
  document.querySelectorAll('.bloom-upsell-option').forEach(function (opt) {
    opt.addEventListener('click', function () {
      /* Deselect all options across both mobile and desktop */
      document.querySelectorAll('.bloom-upsell-option').forEach(function (o) {
        o.classList.remove('selected');
      });
      this.classList.add('selected');

      var qty = parseInt(this.dataset.qty || '1', 10);

      /* Update both qty inputs */
      ['bloom-qty-input', 'bloom-qty-input-d'].forEach(function (id) {
        var input = document.getElementById(id);
        if (input) input.value = qty;
      });

      refreshUI();
    });
  });

  /* ---- DELIVERY DATE ---- */
  function getDeliveryDate() {
    var today = new Date();
    var days  = 0;
    var added = 0;
    while (added < 5) {
      days++;
      var d   = new Date(today);
      d.setDate(today.getDate() + days);
      var dow = d.getDay();
      if (dow !== 0 && dow !== 6) added++;
    }
    var delivery = new Date(today);
    delivery.setDate(today.getDate() + days);
    return delivery.toLocaleDateString('en-US', {
      weekday: 'short',
      month:   'long',
      day:     'numeric'
    });
  }

  var deliveryStr = getDeliveryDate();
  /* Update both mobile and desktop date elements */
  ['bloom-delivery-date', 'bloom-delivery-date-d'].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) el.textContent = deliveryStr;
  });

  /* ---- STICKY ATC ---- */
  var mainAtc  = document.getElementById('bloom-atc-btn');
  var stickyBar = document.getElementById('bloom-sticky-bar');

  if (mainAtc && stickyBar) {
    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        stickyBar.classList.toggle('visible', !entry.isIntersecting);
        stickyBar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
      },
      { threshold: 0, rootMargin: '0px 0px -80px 0px' }
    );
    observer.observe(mainAtc);

    var stickyBtn = document.getElementById('bloom-sticky-btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () { mainAtc.click(); });
    }
  }

  /* ---- SIZE GUIDE MODAL ---- */
  var modal    = document.getElementById('bloom-size-modal');
  var openBtns = document.querySelectorAll('.bloom-size-guide-link');
  var closeBtn  = document.getElementById('bloom-modal-close');
  var backdrop  = document.getElementById('bloom-modal-backdrop');

  function openModal() {
    if (modal) { modal.hidden = false; document.body.style.overflow = 'hidden'; }
  }
  function closeModal() {
    if (modal) { modal.hidden = true;  document.body.style.overflow = ''; }
  }

  openBtns.forEach(function (b) { b.addEventListener('click', openModal); });
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (backdrop)  backdrop.addEventListener('click', closeModal);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

  /* ---- INITIAL RENDER ---- */
  refreshUI();
});
